﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventTemplateList from './tpl/customEventTemplateList.html';
import View_CustomEventTemplateListItem from './customEventTemplateListItem';

export default Marionette.CollectionView.extend({
    //tagName: 'div',
    childViewContainer: '#customEventTemplateList',
    childView: View_CustomEventTemplateListItem,
    getTemplate: function () {
        return tpl_customEventTemplateList();
    },
    attributes: function () {
        return {
            class: 'row',
        }
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});